import { DAS_SOCKET_DATA, DTS_SOCKET_DATA, SAND_INGRSS_GRAPH_CONFIG } from './constants';


export default function sandingressData(state, action) {

	switch (action.type) {
	case DTS_SOCKET_DATA : 	
		return { ...state, dtsData: action.payload };

	case DAS_SOCKET_DATA : 	
		return { ...state, dasData: action.payload };

	case SAND_INGRSS_GRAPH_CONFIG:
		return { ...state, graphConfig : action.payload && action.payload.data ? action.payload.data[0] : {}};

	default: 
		throw Error('Unknown action: ' + action.type);
      
	}
}